import { render, staticRenderFns } from "./ColdCallRules.vue?vue&type=template&id=13e142f2"
import script from "./ColdCallRules.vue?vue&type=script&lang=js"
export * from "./ColdCallRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports